interface WordPressTag {
  id: number;
  name: string;
  slug: string;
}

interface WordPressAuthor {
  id: number;
  name: string;
  description: string;
  avatar_urls?: {
    [key: string]: string;
  };
  url?: string;
}

interface WordPressPost {
  id: number;
  date: string;
  title: {
    rendered: string;
  };
  excerpt: {
    rendered: string;
  };
  content: {
    rendered: string;
  };
  link: string;
  featured_media_url?: string;
  featured_media: number;
  tags: WordPressTag[];
  author: number;
  _embedded?: {
    author?: WordPressAuthor[];
    'wp:featuredmedia'?: Array<{
      source_url: string;
      alt_text?: string;
      media_details?: {
        width: number;
        height: number;
      };
    }>;
  };
  yoast_head_json?: {
    title: string;
    description: string;
    og_title: string;
    og_description: string;
    og_image: string[];
  };
  slug: string;
}

interface WordPressResponse {
  posts: WordPressPost[];
  totalPages: number;
  totalPosts: number;
}

export async function getWordPressPosts(page = 1, perPage = 9): Promise<WordPressResponse> {
  try {
    const response = await fetch(
      `https://blog.pokemonpocket.fr/wp-json/wp/v2/posts?_embed&page=${page}&per_page=${perPage}`,
      { headers: { 'Accept': 'application/json' } }
    );
    
    const posts = await response.json();
    const totalPosts = Number(response.headers.get('X-WP-Total'));
    const totalPages = Number(response.headers.get('X-WP-TotalPages'));

    return {
      posts: posts.map((post: any) => ({
        ...post,
        featured_media_url: post._embedded?.['wp:featuredmedia']?.[0]?.source_url,
        slug: post.slug
      })),
      totalPages,
      totalPosts
    };
  } catch (error) {
    console.error('Error fetching WordPress posts:', error);
    return { posts: [], totalPages: 0, totalPosts: 0 };
  }
}

export async function getWordPressPost(id: number): Promise<WordPressPost> {
  try {
    const [postResponse, tagsResponse] = await Promise.all([
      fetch(`https://blog.pokemonpocket.fr/wp-json/wp/v2/posts/${id}?_embed&_fields=id,date,title,content,excerpt,link,featured_media,_embedded,yoast_head_json`),
      fetch(`https://blog.pokemonpocket.fr/wp-json/wp/v2/tags?post=${id}`)
    ]);

    const post = await postResponse.json();
    const tags = await tagsResponse.json();

    return {
      ...post,
      tags,
      featured_media_url: post._embedded?.['wp:featuredmedia']?.[0]?.source_url
    };
  } catch (error) {
    console.error('Error fetching WordPress post:', error);
    throw error;
  }
}

async function getWordPressAuthor(authorId: number): Promise<WordPressAuthor> {
  try {
    const response = await fetch(
      `https://blog.pokemonpocket.fr/wp-json/wp/v2/users/${authorId}`
    );
    
    if (!response.ok) {
      throw new Error('Author not found');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching WordPress author:', error);
    throw error;
  }
}

export async function getWordPressPostBySlug(slug: string): Promise<WordPressPost> {
  try {
    const postResponse = await fetch(
      `https://blog.pokemonpocket.fr/wp-json/wp/v2/posts?_embed&slug=${slug}`
    );
    
    if (!postResponse.ok) {
      throw new Error('Post not found');
    }
    
    const posts = await postResponse.json();
    if (posts.length === 0) {
      throw new Error('Post not found');
    }

    const post = posts[0];
    console.log('Post complet:', post);
    console.log('Featured media:', post._embedded?.['wp:featuredmedia']?.[0]?.source_url);

    // Récupérer les tags et l'auteur en parallèle
    const [tags, author] = await Promise.all([
      fetch(`https://blog.pokemonpocket.fr/wp-json/wp/v2/tags?post=${post.id}`).then(res => res.json()),
      getWordPressAuthor(post.author)
    ]);

    const featured_media_url = post._embedded?.['wp:featuredmedia']?.[0]?.source_url;
    console.log('URL de l\'image principale:', featured_media_url);

    return {
      ...post,
      tags,
      featured_media_url,
      _embedded: {
        ...post._embedded,
        author: [author]
      }
    };
  } catch (error) {
    console.error('Error fetching WordPress post:', error);
    throw error;
  }
}
